<template>
	<section class="decoration-edit">
		<section class="l">
			<ul @dragstart="dragStart" @dragend="dragEnd">
				<li v-for="(val, key, index) in typeList" draggable :data-type="key" :key="index + 1">
					<span :class="val.icon"></span>
					<p>{{ val.name }}</p>
				</li>
			</ul>
		</section>
		<section class="c">
			<!-- header 不可拖拽 -->
			<div class="top-nav" @click="selectType(0)">
				<img src="./../assets/images/topNavBlack.png" />
				<span class="tit">{{ info.title }}</span>
			</div>
			<div class="view-content" @drop="drog" @dragover="dragOver" :style="{ backgroundColor: info.backgroundColor, backgroundImage: 'url(' + info.backgroundImage + ')' }">
				<Draggable v-model="view" draggable=".item">
					<template v-for="(item, index) in view">
						<div v-if="index > 0" :data-index="index" :key="index" class="item" @click="selectType(index)" :style="{ zIndex: index, overflow: overflow }">
							<!-- waiting -->
							<template v-if="item.status && item.status == 2">
								<div class="wait">{{ item.type }}</div>
							</template>
							<template v-else>
								<component :is="typeList[item.type]['com']" :data="item" :className="className[item.tabType]"></component>
							</template>
							<i @click="deleteItem($event, index)" class="el-icon-error"></i>
						</div>
					</template>
				</Draggable>
			</div>
		</section>
		<section class="r">
			<EditForm :data="props" v-if="isRight"></EditForm>
		</section>

		<div class="submit-btn">
			<el-button @click="submit">提交页面</el-button>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import Draggable from 'vuedraggable';
import EditForm from '@/components/Edit/index';
import Product from '@/components/View/Product';
import Images from '@/components/View/Images';
import Banner from '@/components/View/Banner';
import imageAndText from '@/components/View/imageAndText';
import videoAndText from '@/components/View/videoAndText';
import fromInfo from '@/components/View/fromInfo';
import button_component from '@/components/View/button_component';
import text_component from '@/components/View/text_component';
import video_component from '@/components/View/video_component';
import bookShelf from '@/components/View/bookShelf';
import courseVideo from '@/components/View/courseVideo';
import courseCatalogue from '@/components/View/courseCatalogue';
import bookLink from '@/components/View/bookLink';
import CourseIntroduction from '@/components/View/CourseIntroduction';
import relatedReading from '@/components/View/relatedReading';
import doctorsSharing from '@/components/View/doctorsSharing';
import combinedMedica from '@/components/View/combinedMedica';
import productDisplay from '@/components/View/productDisplay';

export default {
	components: {
		EditForm,
		Draggable,
		Product,
		Images,
		Banner,
		imageAndText,
		videoAndText,
		fromInfo,
		button_component,
		text_component,
		video_component,
		bookShelf,
		courseVideo,
		courseCatalogue,
		bookLink,
		CourseIntroduction,
		relatedReading,
		doctorsSharing,
		combinedMedica,
		productDisplay,
	},
	data() {
		return {
			typeList: {
				banner: {
					name: '轮播图',
					icon: 'el-icon-s-unfold',
					com: Banner,
				},
				product: {
					name: '商品',
					icon: 'el-icon-s-goods',
					com: Product,
				},
				images: {
					name: '图片',
					icon: 'el-icon-picture',
					com: Images,
				},
				imageAndText: {
					name: '图文组件',
					icon: 'el-icon-document',
					com: imageAndText,
				},
				videoAndText: {
					name: '视文组件',
					icon: 'el-icon-video-camera',
					com: videoAndText,
				},
				fromInfo: {
					name: '表单信息',
					icon: 'el-icon-edit-outline',
					com: fromInfo,
				},
				button_component: {
					name: '表单按钮',
					icon: 'el-icon-thumb',
					com: button_component,
				},
				text_component: {
					name: '文字',
					icon: 'el-icon-postcard',
					com: text_component,
				},
				video_component: {
					name: '视频',
					icon: 'el-icon-video-play',
					com: video_component,
				},
				bookShelf: {
					name: '书架',
					icon: 'el-icon-notebook-2',
					com: bookShelf,
				},
				courseVideo: {
					name: '课程视频',
					icon: 'el-icon-video-camera',
					com: courseVideo,
				},
				courseCatalogue: {
					name: '课程目录',
					icon: 'el-icon-reading',
					com: courseCatalogue,
				},
				CourseIntroduction: {
					name: '课程简介',
					icon: 'el-icon-document',
					com: CourseIntroduction,
				},
				bookLink: {
					name: '电子书跳转',
					icon: 'el-icon-position',
					com: bookLink,
				},
				relatedReading: {
					name: '相关阅读',
					icon: 'el-icon-notebook-1',
					com: relatedReading,
				},
				doctorsSharing: {
					name: '名医分享',
					icon: 'el-icon-share',
					com: doctorsSharing,
				},
				combinedMedica: {
					name: '联合用药',
					icon: 'el-icon-first-aid-kit',
					com: combinedMedica,
				},
				productDisplay: {
					name: '产品展示',
					icon: 'el-icon-copy-document',
					com: productDisplay,
				},
			},
			view: [
				{
					type: 'info',
					title: '这个是标题!',
					backgroundImage: '',
				},
			],
			title: '页面标题',
			type: '',
			index: null, // 当前组件的索引
			isPush: false, // 是否已添加组件
			overflow: 'visible',

			props: {}, // 传值
			isRight: false,

			className: {
				1: 'one',
				2: 'two',
				3: 'three',
			},
			aiId: '', //活动id
			atId: '', //模板的id
			apId: '', //活动的详情id
			token: '',
			linkType: '', //链接类型  (模板)
		};
	},
	computed: {
		info() {
			return this.view[0];
		},
	},
	created() {
		window.addEventListener('message', this.handleMessage);
	},

	methods: {
		handleMessage(event) {
			const data = event.data;
			if (data.info == 'success') {
				this.aiId = data.aiId;
				this.atId = data.atId;
				this.token = data.token;
				this.apId = data.apId;
				this.linkType = data.linkType;
				if (data.data != 'null' && data.data != null && data.data != undefined && data.data.length > 0) {
					var newData = JSON.parse(data.data);
					for (var i = 0; i < newData.length; i++) {
						newData[i]['token'] = this.token;
						newData[i]['aiId'] = this.aiId;
					}
					this.view = newData;
					// this.view[0].title = data.actName;
				} else {
					this.view = [
						{
							type: 'info',
							title: data.actName,
							backgroundImage: '',
						},
					];
				}
			}
		},
		submit() {
			// JSON 转换会丢失 formData
			const form = JSON.parse(JSON.stringify(this.view));
			if (form.length == 1) {
				this.$message.error('请添加模块！');
				return;
			}
			for (let i of form) {
				if (i.type != 'info') {
					if (i.data.length == 0 && !i.content) {
						this.$message.error('请填写完整信息！');
						return;
					}
					// if (i.type === 'product') {
					// 	i.data = i.data.map((val) => val.productId).join(',');
					// }
				}
			}

			console.log('form', form); // 提交的数据，根据接口形式修改
			console.log('this.atId', this.atId);
			console.log('this.token', this.token);

			if (this.linkType == 'template') {
				this.is_template_submit();
				return false;
			}
			var activityInfo_page_edit = process.env.VUE_APP_BASE_API + '/act/page/update';
			var apLinkUrl = process.env.VUE_APP_visualization_H5 + this.apId;
			console.log(this.apId);
			axios
				.put(
					activityInfo_page_edit,
					{
						apId: this.apId,
						apContent: JSON.stringify(form),
						apLinkUrl: apLinkUrl,
					},
					{
						headers: {
							Authorization: 'Bearer ' + this.token,
						},
					}
				)
				.then((res) => {
					if (res.data.code != 200) return false;
					this.$message.success('修改成功');
				});
		},

		//模板提交
		is_template_submit() {
			const form = JSON.parse(JSON.stringify(this.view));
			var activityInfo_page_edit = process.env.VUE_APP_BASE_API + '/act/template/update';
			var apLinkUrl = process.env.VUE_APP_visualization_H5 + this.atId;
			axios
				.put(
					activityInfo_page_edit,
					{
						atId: this.atId,
						atContent: JSON.stringify(form),
						atLinkUrl: apLinkUrl,
					},
					{
						headers: {
							Authorization: 'Bearer ' + this.token,
						},
					}
				)
				.then((res) => {
					if (res.data.code != 200) return false;
					this.$message.success('修改成功');
				});
		},

		// 切换视图组件
		selectType(index) {
			this.isRight = false;
			this.props = this.view[index];
			this.$nextTick(() => (this.isRight = true));
		},
		deleteItem(e, index) {
			e.preventDefault();
			e.stopPropagation();
			this.view.splice(index, 1);
			this.isRight = false;
			this.props = {};
		},
		// 拖拽类型
		dragStart(e) {
			this.type = e.target.dataset.type;
			this.overflow = 'hidden';
		},
		// 结束拖拽
		dragEnd(e) {
			if (!this.view[this.index]) return false;
			this.$delete(this.view[this.index], 'status');
			this.isPush = false;
			this.type = null;
			this.overflow = 'visible';
		},
		// 已放置到指定位置
		drog(e) {
			if (!this.type) {
				// 内容拖拽
				return;
			}
			e.preventDefault();
			e.stopPropagation();
			this.dragEnd();
		},
		// 移动中
		dragOver(e) {
			if (!this.type) {
				// 内容拖拽
				return;
			}
			e.preventDefault();
			e.stopPropagation();

			let className = e.target.className;
			let name = className !== 'view-content' ? 'item' : 'view-content';

			const defaultData = {
				type: this.type, // 组件类型
				status: 2, // 默认状态
				data: [], // 数据
				options: {}, // 选项操作
				aiId: this.aiId ? this.aiId : '',
				token: this.token,
			};
			//如果是书架的情况增加两个参数
			if (this.type == 'bookShelf') {
				defaultData.titleImage = '';
				defaultData.backgroundImage = '';
				defaultData.content = '书架组件';
			}
			//如果是课程视频
			if (this.type == 'courseVideo') {
				defaultData.topImage = '';
				defaultData.backgroundImage = '';
				defaultData.bottomImage = '';
				defaultData.listImage = '';
				defaultData.styleSelect = 'is_style_ly';
			}
			//如果是课程简介
			if (this.type == 'CourseIntroduction') {
				defaultData.styleSelect = 'is_style_ly';
			}
			//如果是提交按钮
			if (this.type == 'button_component') {
				defaultData.subType = 'SK';
			}

			//如果是相关阅读 或 名医分享 或 联合用药 或 产品展示
			if (this.type == 'relatedReading' || this.type == 'doctorsSharing' || this.type == 'combinedMedica' || this.type == 'productDisplay') {
				defaultData.backgroundImage = '';
			}

			if (name == 'view-content') {
				if (!this.isPush) {
					this.index = this.view.length;
					this.isPush = true;
					this.view.push(defaultData);
				}
			} else if (name == 'item') {
				let target = e.target;
				let [y, h, curIndex] = [e.offsetY, target.offsetHeight, target.dataset.index];
				let direction = y < h / 2;
				if (!this.isPush) {
					// Push to Top or Bottom
					if (direction) {
						if (curIndex == 0) {
							this.view.unshift(defaultData);
						} else {
							this.view.splice(curIndex, 0, defaultData);
						}
					} else {
						curIndex = +curIndex + 1;
						this.view.splice(curIndex, 0, defaultData);
					}
				} else {
					if (direction) {
						var i = curIndex == 0 ? 0 : curIndex - 1;
						var result = this.view[i]['status'] == 2;
					} else {
						var i = +curIndex + 1;
						var result = this.view.length > i && this.view[i]['status'] == 2;
					}
					if (result) return;
					const temp = this.view.splice(this.index, 1);
					this.view.splice(curIndex, 0, temp[0]);
				}
				this.index = curIndex;
				this.isPush = true;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.decoration-edit {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 0;
	background: #f7f8f9;
	height: calc(100vh - 50px);
	position: relative;
	.l,
	.r {
		width: 340px;
		height: 100%;
		padding: 15px 0;
		background: #fff;
	}
	.l {
		ul {
			margin: 0;
			padding: 0;
			li {
				width: 80px;
				height: 80px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				cursor: default;
				list-style: none;
				font-size: 14px;
				color: #666;
				float: left;
				margin: 0 10px;
				border-radius: 6px;
				transition: all 0.3s;
				cursor: pointer;
				&:hover {
					background: #efefef;
				}
				span {
					display: block;
					font-size: 40px;
					margin-bottom: 8px;
					color: #999;
				}
				p {
					display: block;
					margin: 0;
					font-size: 12px;
				}
			}
		}
	}
	.c {
		width: 375px;
		max-width: 400px;
		position: relative;
		.top-nav {
			position: absolute;
			top: 0;
			background: #fff;
			z-index: 999;
			transition: all 0.3s;
			& * {
				pointer-events: none;
			}
			&:hover {
				transform: scale(0.95);
				border-radius: 10px;
				overflow: hidden;
				box-shadow: 0 0 10px #afafaf;
			}
			.tit {
				position: absolute;
				left: 50%;
				bottom: 10px;
				transform: translateX(-50%);
			}
			img {
				max-width: 100%;
				image-rendering: -moz-crisp-edges;
				image-rendering: -o-crisp-edges;
				image-rendering: -webkit-optimize-contrast;
				image-rendering: crisp-edges;
				-ms-interpolation-mode: nearest-neighbor;
			}
		}
		.view-content {
			height: 667px;
			background: #f5f5f5;
			overflow-y: auto;
			overflow-x: hidden;
			padding-top: 72px;
			box-shadow: 0 2px 6px #ccc;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			&::-webkit-scrollbar {
				width: 6px;
			}
			&::-webkit-scrollbar-thumb {
				background: #dbdbdb;
			}
			&::-webkit-scrollbar-track {
				background: #f6f6f6;
			}

			.item {
				transition: all 0.3s;
				position: relative;
				// background: #fff;
				&:hover {
					transform: scale(0.95);
					border-radius: 10px;
					box-shadow: 0 0 10px #afafaf;
					.el-icon-error {
						display: block;
					}
				}
				div {
					pointer-events: none;
				}
				.wait {
					background: #deedff;
					height: 35px;
					text-align: center;
					line-height: 35px;
					font-size: 12px;
					color: #666;
				}
				.el-icon-error {
					position: absolute;
					right: 0px;
					top: 0px;
					color: red;
					font-size: 25px;
					cursor: pointer;
					display: none;
					z-index: 9999;
				}
			}
		}
	}
	.submit-btn {
		position: absolute;
		bottom: 15px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 999;
	}
}
</style>